import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';

export const ButtonWrapper = styled(Box)`
  position: absolute;
  max-height: 52px;
  z-index: 2;
  padding: 8px 8px 16px 8px;
  border-radius: 6px;
  ${({ theme }) => css`
    right: ${theme.spacing(1)};
    bottom: 0;
  `}
`;
